const types = {
  FETCH_CONSIGNER_PLAN_DETAILS_START: 'FETCH_CONSIGNER_PLAN_DETAILS_START',
  FETCH_CONSIGNER_PLAN_DETAILS_SUCCESS: 'FETCH_CONSIGNER_PLAN_DETAILS_SUCCESS',
  FETCH_CONSIGNER_PLAN_DETAILS_FAILURE: 'FETCH_CONSIGNER_PLAN_DETAILS_FAILURE',
  INITIATE_CONSIGNER_PLAN_PAYMENT_START: 'INITIATE_CONSIGNER_PLAN_PAYMENT_START',
  INITIATE_CONSIGNER_PLAN_PAYMENT_SUCCESS: 'INITIATE_CONSIGNER_PLAN_PAYMENT_SUCCESS',
  INITIATE_CONSIGNER_PLAN_PAYMENT_FAILURE: 'INITIATE_CONSIGNER_PLAN_PAYMENT_FAILURE',
  INITIATE_CONSIGNER_PLAN_PAYMENT_STATUS_START: 'INITIATE_CONSIGNER_PLAN_PAYMENT_STATUS_START',
  INITIATE_CONSIGNER_PLAN_PAYMENT_STATUS_SUCCESS: 'INITIATE_CONSIGNER_PLAN_PAYMENT_STATUS_SUCCESS',
  INITIATE_CONSIGNER_PLAN_PAYMENT_STATUS_FAILURE: 'INITIATE_CONSIGNER_PLAN_PAYMENT_STATUS_FAILURE',
};
export default types;
